import { defineStore } from 'pinia';

/**
 * Pure UI-coordination state for the Tutorials panel — no domain data, mirroring
 * useTopBarStore.js's shape. Needed because the trigger row (Dropdown/Menu.vue,
 * Header/Mobile.vue), the panel itself (mounted app-wide in app.vue), and
 * MobileNavBar.vue's slide-out account menu are three separate component trees with
 * no other way to reach each other.
 */
export const useTutorialsPanelStore = defineStore('tutorialsPanelStore', {
  state: () => {
    return {
      isPanelOpen: false,
      // Incremented, never read as a boolean: MobileNavBar watches for a *change*,
      // not a value, since "close" has no natural opposite to toggle back from.
      mobileMenuCloseRequestId: 0,
    };
  },
  actions: {
    openPanel() {
      this.isPanelOpen = true;
    },
    closePanel() {
      this.isPanelOpen = false;
    },
    requestMobileMenuClose() {
      this.mobileMenuCloseRequestId += 1;
    },
  },
});
